module.exports = __webpack_public_path__ + "@/assets/img/chart-pie.eef7bb66.svg";